import { render, staticRenderFns } from "./UpdateTicketTypeView.vue?vue&type=template&id=1530d675"
import script from "./UpdateTicketTypeView.vue?vue&type=script&lang=js"
export * from "./UpdateTicketTypeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports